import React from "react";
import ModalItemComponent from "./ModalItemComponent";

export default function Modals({ modals }) {
  return (
    <>
      {modals.map(modal => {
        return (
          <ModalItemComponent
            key={modal.id}
            options={modal.options}
            component={modal.component}
            headerIcon={modal.headerIcon}
            hideHeader={modal.hideHeader}
            showDivider={modal.showDivider}
            modalHeader={modal.modalHeader}
            showCloseIcon={modal.showCloseIcon}
            onCloseIconClick={modal.onCloseIconClick}
            modalSubHeader={modal.modalSubHeader}
            componentProps={modal.componentProps}
            pathIllustration={modal.pathIllustration}
          />
        );
      })}
    </>
  );
}
